import React, { useState } from 'react'
import { ObjectSelectSectionProps } from './ObjectSelectSection.types'
import styles from './ObjectSelectSection.module.scss'
import cl from 'classnames'
import { Button } from '../Button'
import { Text1 } from '../Text1'
import { Checkbox } from '../Checkbox'
import { Input } from '../Input'
import { HorizontalLine } from '../HorizontalLine'
import { ObjectSelectButton } from './ObjectSelectButton'

const ObjectSelectSectionComponent = (props: ObjectSelectSectionProps) => {
  const {
    list,
    selected,
    onSelectAllClick,
    onObjectClick
  } = props

  const selectedIds = selected.map(obj => obj.id)
  const areAllSelected = Boolean(list.length && selected.length === list.length)

  const [searchText, setSearchText] = useState('')

  return (
    <div className={cl(styles.container)}>
      <div className={styles.header}>
        <Button
          preset='icon'
          onClick={onSelectAllClick}
        >
          <Checkbox isChecked={areAllSelected} />
          <Text1 style={{ marginLeft: 10 }}>
            Select all
          </Text1>
          <Text1
            className={styles.secondaryText}
            style={{ marginLeft: 6 }}
          >
            ({selected.length}/{list.length})
          </Text1>
        </Button>
        <Input
          containerProps={{ style: { width: 300 } }}
          placeholder='Search...'
          value={searchText}
          onChange={setSearchText}
        />
      </div>
      <HorizontalLine className={styles.horizontalLine} />
      <div className={cl(styles.objectsContainer, styles.scrollable)}>
        {list
          .filter(obj => obj.label.toLowerCase().includes(searchText.trim().toLowerCase()))
          .map(objectProps => {
            return (
              <ObjectSelectButton
                key={objectProps.id}
                isSelected={selectedIds.includes(objectProps.id)}
                onClick={() => onObjectClick(objectProps.id)}
                isRemovable={true}
                {...objectProps}
              />
            )
          })}
      </div>
    </div>
  )
}

const ObjectSelectSection = ObjectSelectSectionComponent
export { ObjectSelectSection }
